import { render, staticRenderFns } from "./RelaySerTable.vue?vue&type=template&id=c06cfc02"
import script from "./RelaySerTable.vue?vue&type=script&lang=js"
export * from "./RelaySerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports